import { Card } from "../../../../../components/Card";
import { CarbonValuesChart } from "./index";
import { Text, Link, Box } from "@chakra-ui/react";

function CarbonPriceTracker() {
  return (
    <Card>
      <Box marginBottom="10">
        <CarbonValuesChart />
        <Text marginTop="5">Source - UK Government carbon values</Text>
        <Link
          color={"esg_blue"}
          textDecoration="underline"
          isExternal
          href="https://www.gov.uk/government/publications/valuing-greenhouse-gas-emissions-in-policy-appraisal/valuation-of-greenhouse-gas-emissions-for-policy-appraisal-and-evaluation">
          https://www.gov.uk/government/publications/valuing-greenhouse-gas-emissions-in-policy-appraisal/valuation-of-greenhouse-gas-emissions-for-policy-appraisal-and-evaluation
        </Link>
      </Box>

      <Box>
        <iframe
          title={"title"}
          width="100%"
          height="700"
          style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
          src="https://flo.uri.sh/visualisation/12603037/embed?auto=1"
          allowFullScreen
        />
        <Text marginTop="5">Source - Tracking carbon price for ETS</Text>
        <Link
          color={"esg_blue"}
          textDecoration="underline"
          isExternal
          href="https://ember-climate.org/data/data-tools/carbon-price-viewer/">
          https://ember-climate.org/data/data-tools/carbon-price-viewer/
        </Link>
      </Box>
    </Card>
  );
}

export default CarbonPriceTracker;